/**
 * Depot Controller
 * Handles all depot-related API calls
 */

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getAuthHeaders = () => {
  const authToken = localStorage.getItem('authToken');
  return {
    Authorization: authToken ? `Bearer ${authToken}` : ''
  };
};

const DepotController = {
  fetchDepots: async (pageNumber = 1, size = 10, searchTerm = '') => {
    let url = `${API_URL}/Depot/Pagination?Size=${size}&PageNumber=${pageNumber}`;
    if (searchTerm) url += `&Search=${encodeURIComponent(searchTerm)}`;
    const response = await axios.get(url, { headers: getAuthHeaders() });
    return response.data;
  },

  getAllDepots: async () => {
    const response = await axios.get(`${API_URL}/Depot`, { headers: getAuthHeaders() });
    return response.data;
  },

  getDepotById: async (id) => {
    const response = await axios.get(`${API_URL}/Depot/byId/${id}`, { headers: getAuthHeaders() });
    return response.data;
  },

  createDepot: async (data) => {
    const response = await axios.post(`${API_URL}/Depot`, data, { headers: getAuthHeaders() });
    return response.data;
  },

  updateDepot: async (data) => {
    const response = await axios.put(`${API_URL}/Depot`, data, { headers: getAuthHeaders() });
    return response.data;
  },

  deleteDepot: async (id) => {
    await axios.delete(`${API_URL}/Depot/${id}`, { headers: getAuthHeaders() });
    return true;
  },
};

export default DepotController;
